import React, { useState, useEffect } from 'react'
import { Pagination, Spin } from 'antd'
import SearchField from '../../home/components/filters/SearchField'
import SelectFilterOptions from '../../shared/SelectFilterOptions'
import { getFbaItemsByDesign } from '../../../services/api/3dApi'
import FbaItemDesignRow from './FbaItemDesignRow'

const PUSH_BATCH_OPTIONS = [
    { name: 'Tất cả', value: '' },
    { name: 'Chưa đẩy lô', value: false },
    { name: 'Đã có lô', value: true },
]

const BATCH_STATUS_OPTIONS = [
    { name: 'Tất cả', value: '' },
    { name: 'Đang chờ', value: 'pending' },
    { name: 'Đang in', value: 'printing' },
    { name: 'Đã in', value: 'printed' },
    { name: 'Đang ép', value: 'transferring' },
    { name: 'Đã ép', value: 'transferred' },
    { name: 'Chờ may', value: 'wait_to_sew' },
    { name: 'Đang may', value: 'sewing' },
    { name: 'Hoàn thành', value: 'completed' },
    { name: 'Chưa hoàn thành', value: 'incomplete' },
]

const FbaItemDesignPage = () => {
    const [filters, setFilters] = useState({
        type: '',
        order_number: '',
        fac_codes: '',
        size: '',
        in_batch: '',
        batch_status: 'incomplete',
    })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(100)
    const [total, setTotal] = useState(0)

    const fetchData = async () => {
        setLoading(true)
        setError('')
        setData([])

        try {
            const { type, order_number, fac_codes, size, in_batch, batch_status } = filters
            const payload = { page, limit }

            if (type) payload.type = type.split(/[,\s]+/).filter(Boolean)
            if (order_number) payload.order_number = order_number.split(/[,\s]+/).filter(Boolean)
            if (fac_codes) payload.fac_codes = fac_codes.split(/[,\s]+/).filter(Boolean)
            if (size) payload.size = size.split(',').map(s => s.trim()).filter(Boolean)
            if (in_batch !== '') payload.in_batch = in_batch
            if (batch_status) payload.batch_status = batch_status

            const { data: res } = await getFbaItemsByDesign(payload)
            const { success, data: responseData, message, error: errMsg } = { ...res }

            if (!success) return setError(message || errMsg || 'Có lỗi xảy ra')

            const { groups = [], total: totalCount = 0 } = responseData || {}
            
            setData(groups)
            setTotal(totalCount)
        } catch (e) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    const handleChangeField = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: value !== undefined ? value : '' }))
        setPage(1)
    }

    const handlePageChange = (p) => setPage(p)

    const handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    useEffect(() => {
        fetchData()
    }, [filters, page, limit])

    return (
        <div className='FbaItemDesignPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mt-3'>
                        <div className='d-flex align-items-center mb-3'>
                            <h3 className='m-0'>Danh sách item đơn FBA theo design</h3>
                        </div>

                        <div className='jumbotron px-3 pb-0 pt-3 mb-3'>
                            <div className='FbaItemDesignFilters'>
                                <div className='row align-items-end'>
                                    <div className='col-12 col-md-6 col-xl-2 mb-3'>
                                        <SearchField
                                            field='type'
                                            title='SKU'
                                            placeholder='Tìm kiếm nhiều SKU...'
                                            onChangeInput={handleChangeField}
                                        />
                                    </div>

                                    <div className='col-12 col-md-6 col-xl-2 mb-3'>
                                        <SearchField
                                            field='order_number'
                                            title='Order'
                                            placeholder='Mã order...'
                                            onChangeInput={handleChangeField}
                                        />
                                    </div>

                                    <div className='col-12 col-md-6 col-xl-2 mb-3'>
                                        <SearchField
                                            field='fac_codes'
                                            title='Barcode item'
                                            placeholder='Nhập barcode...'
                                            onChangeInput={handleChangeField}
                                        />
                                    </div>

                                    <div className='col-12 col-md-6 col-xl-2 mb-3'>
                                        <SearchField
                                            field='size'
                                            title='Size'
                                            placeholder='Tìm kiếm nhiều size...'
                                            onChangeInput={handleChangeField}
                                        />
                                    </div>

                                    <div className='col-12 col-md-6 col-xl-2 mb-3'>
                                        <SelectFilterOptions
                                            field='in_batch'
                                            label='Đẩy lô'
                                            listOptions={PUSH_BATCH_OPTIONS}
                                            value={filters.in_batch}
                                            handleChange={handleChangeField}
                                            style={{ width: '100%' }}
                                        />
                                    </div>

                                    <div className='col-12 col-md-6 col-xl-2 mb-3'>
                                        <SelectFilterOptions
                                            field='batch_status'
                                            label='Trạng thái lô'
                                            listOptions={BATCH_STATUS_OPTIONS}
                                            value={filters.batch_status}
                                            handleChange={handleChangeField}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='d-flex justify-content-between align-items-center mb-3'>
                            <div>
                                {error && <div className='text-danger'>{error}</div>}
                            </div>
                        </div>

                        <div className='FbaItemDesignTable'>
                            <Spin spinning={loading} tip='Đang tải...'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>STORE / ORDER</th>
                                            <th>DESIGN</th>
                                            <th>FILE IN</th>
                                            <th>SKU</th>
                                            <th>SIZE</th>
                                            <th>SỐ LƯỢNG</th>
                                            <th>DETAIL</th>
                                            <th>TÊN LÔ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length > 0 ? (
                                            data.map((item, index) => (
                                                <FbaItemDesignRow
                                                    key={item.checksum_design || index}
                                                    item={item}
                                                    rowIndex={index}
                                                />
                                            ))
                                        ) : (
                                            !loading && (
                                                <tr>
                                                    <td colSpan={8} className='text-center py-4 text-muted'>
                                                        Không có dữ liệu
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </Spin>
                        </div>

                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            onChange={handlePageChange}
                            showQuickJumper
                            className='CustomPagination text-right mt-3'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FbaItemDesignPage
